import { createFeature, createReducer, on } from '@ngrx/store';
import { HijosActions } from './hijos.actions';
import { HijosState, initialHijosState } from './hijos.state';

const reducer = createReducer(
  initialHijosState,
  on(HijosActions.loadHijos, (state) => ({ ...state, loading: true, error: null })),
  on(HijosActions.loadHijosSuccess, (state, { hijos }) => ({ ...state, hijos, loading: false })),
  on(HijosActions.loadHijosFailure, (state, { error }) => ({ ...state, loading: false, error })),
);

export const hijosFeature = createFeature<'hijos', HijosState>({
  name: 'hijos',
  reducer,
});
